/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates an energy cost savings section
 *
 * <energy-cost-savings> </energy-cost-savings>
 *
 */
/**
 * @module enervee_utils.product_sections
 */
function energyCostSavingsDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '<?',
        },
        controller: energyCostSavingsController,
        template: require('./energyCostSavingsView.html')
    };
}

energyCostSavingsController.$inject = [
    '$q',
    '$scope',
    '$timeout',
    '$filter',
    'EnergyCostSavingsService',
    'ProductService',
    'UtilitySelectorService',
    'UtilitySelectorCookieService',
    'UtilService',
    'CmsContentService',
    'AnalyticsService',
];
function energyCostSavingsController (
    $q,
    $scope,
    $timeout,
    $filter,
    EnergyCostSavingsService,
    ProductService,
    UtilitySelectorService,
    UtilitySelectorCookieService,
    UtilService,
    CmsContentService,
    AnalyticsService
) {

    this.$onInit = function () {
        var vm = this;
        const CLEAR_COST_CODE = 'cost';
        const YOUSAVE_CODE = 'savings';

        $scope.utilityRateSelectorEnabled = UtilService.isFeatureEnabled('utility_rate_selector') || UtilService.isFeatureEnabled('utility_state_rate_selector');
        $scope.isEnergyCostSavingStatementProductSpecific = ProductService.getDetailsPageConfig('is_energy_cost_saving_statement_product_specific');
        $scope.informationalTextHTML = ProductService.getDetailsPageConfig('energy_cost_saving_informational_text_html');
        /**
         * FIXME: If a directive requires something from a parent
         * scope, it should have it bound in via an attribute,
         * rather than accessing a controller in the parent scope
         * like this.
         */
        var productId = $scope.product.id;
        $scope.categoryId = $scope.product.category.id;

        $scope.productBrand = $scope.product.brand;
        $scope.productModelNumber = $scope.product.model_number;
        $scope.productCategory = $scope.product.category.name;
        $scope.youSaveText = '';
        $scope.clearCostText = '';

        if ($scope.isEnergyCostSavingStatementProductSpecific) {
            CmsContentService.getMarketPlaceText(
                'details_page:energy_cost_savings:savings_statement_specific',
                {
                    'product_brand': $scope.productBrand,
                    'product_model_number': $scope.productModelNumber,
                    'product_category_lowercase': $scope.productCategory.toLowerCase(),
                },
                $scope.product.category.id
            ).then(function (text) {
                $scope.energySavingsStatementSpecificText = text;
            });
        }

        // Get text to replace CLEARCOST AND YOU SAVE logos
        CmsContentService.getMarketPlaceText('details_page:energy_cost_savings:yousave_logo_text').then(function (text) {
            $scope.youSaveText = text;
        });

        CmsContentService.getMarketPlaceText('details_page:energy_cost_savings:clearcost_logo_text').then(function (text) {
            $scope.clearCostText = text;
        });

        var getUtilityGasRate = function (utility) {
            var utilityRate = parseFloat((utility) ? utility.gas_rate : 0);
            var textfieldRate = parseFloat($scope.energyCostSavingsData.rate_textfield.default);
            return UtilService.roundToFixed((utilityRate || textfieldRate) / 100, 3);
        };

        $scope.costSavingsDropDownSelected = function (value, ignoreTracking) {
            var cost_savings_dropdown = $scope.energyCostSavingsData.cost_savings_dropdown,
                displayName = cost_savings_dropdown.choices[value];
            $scope.selectedCostSavings = {
                'display_name': displayName,
                'value': value
            };

            getCostSavingCalculations(ignoreTracking);
        };

        $scope.costSavingsUsageSelected = function (value) {
            $scope.selectedCostSavingsUsage = value;
            getCostSavingCalculations();
        };

        $scope.costSavingsYearsSelected = function (value) {
            $scope.selectedCostSavingsYears = value;
            getCostSavingCalculations();
        };

        $scope.rateTextFieldChanged = function (value, ignoreTracking) {
            var regEx = /^\d*(\.\d{0,4})?$/;
            if (regEx.test(value)) {
                UtilService.debounce('rateTextFieldChanged', function () {
                    getCostSavingCalculations(ignoreTracking);
                }, 300);
            }
        };

        /**
         * Gets the cost savings initial drop down data and specifies the default values
         *
         */
        var getCostSavingsInitialData = function () {
            EnergyCostSavingsService.getCostSavingsData($scope.categoryId).then(function (energyCostSavingsData) {
                $scope.energyCostSavingsData = energyCostSavingsData;
                if (!$scope.energyCostSavingsData.cost_savings_usage ||
                    !$scope.energyCostSavingsData.cost_savings_years ||
                    !$scope.energyCostSavingsData.rate_textfield ||
                    !$scope.energyCostSavingsData.cost_savings_dropdown
                ) {
                    $scope.hideEnergyCostSavings = true;
                    return;
                }

                $scope.selectedCostSavingsUsage = $scope.energyCostSavingsData.cost_savings_usage.default;
                $scope.selectedCostSavingsYears = $scope.energyCostSavingsData.cost_savings_years.default;
                getUserUtilityRate().then(() => {
                    // Trigger the dropdown, but ignore tracking
                    $scope.costSavingsDropDownSelected($scope.energyCostSavingsData.cost_savings_dropdown.default, true);
                });
            });
        };
        var sendEnergyViewed = function () {
            AnalyticsService.reportEvent('Energy Viewed', {
                type: $scope.energyCostSavingsData.cost_savings_dropdown.default,
                rate: $scope.energyCostSavingsData.rate_textfield.default,
                usage_amount: $scope.energyCostSavingsData.cost_savings_usage.default,
                years: $scope.energyCostSavingsData.cost_savings_years.default
            }, $scope.product);
        };

        $scope.trackEnergyViewed = function () {
            $timeout(sendEnergyViewed, 0);
        };

        /**
         * Performs the check if user's utility rate is stored
         */
        let userUtility;
        const getUserUtilityRate = function () {
            const deferred = $q.defer();

            if ((UtilService.isFeatureEnabled('utility_rate_selector')
                || UtilService.isFeatureEnabled('utility_state_rate_selector'))
                && UtilitySelectorCookieService.isElectricalUtilitySet()) {

                UtilitySelectorService.fetchUserUtility().then(() => {

                    userUtility = UtilitySelectorService.getElectricalUtility();
                    if (!userUtility) {
                        // If the utility saved to the user's profile is null (or the user is not logged in), load the one from the cookie
                        userUtility = UtilitySelectorCookieService.getElectricalUtility();
                    }
                    if ($scope.energyCostSavingsData.rate_textfield.fuel_type === EnergyCostSavingsService.FUEL_TYPE_GAS) {
                        $scope.rateTextField = getUtilityGasRate(userUtility);
                    } else {
                        $scope.rateTextField = UtilitySelectorCookieService.getElectricalUtilityRate();
                    }

                    deferred.resolve();
                }, () => {
                    deferred.resolve();
                });
            } else {
                // If the user has not set a utility or rate, OR neither of the picker
                // features are enabled, we display the default rate
                let rate = parseFloat($scope.energyCostSavingsData.rate_textfield.default);
                if ($scope.energyCostSavingsData.rate_textfield.fuel_type === EnergyCostSavingsService.FUEL_TYPE_GAS) {
                    rate = UtilService.roundToFixed(rate / 100, 3);
                }
                $scope.rateTextField = rate;
                deferred.resolve();
            }

            return deferred.promise;
        };

        /**
         * Listens for changes in the header utility picker and updates
         * cost saving calculations based on the updated rate.
         * FIXME: this logic is repeated in zipCodeSelector and needs abstraction
         */
        if ($scope.utilityRateSelectorEnabled) {
            $scope.$on('utilitySet', function (event, utility) {
                var utilityRate = null;
                if ($scope.energyCostSavingsData.rate_textfield.fuel_type === "gas") {
                    $scope.rateTextField = getUtilityGasRate(utility);
                    utilityRate = $scope.rateTextField;
                } else {
                    if ('user_set_electrical_rate' in utility && utility.user_set_electrical_rate !== null) {
                        utilityRate = utility.user_set_electrical_rate;
                    } else if ('electrical_rate' in utility && utility.electrical_rate !== null) {
                        utilityRate = utility.electrical_rate;
                    } else if ('residential_rate' in utility && utility.residential_rate !== null) {
                        utilityRate = utility.residential_rate;
                    } else if ('electricalRate' in utility && utility.electricalRate !== null) {
                        utilityRate = utility.electricalRate;
                    }
                }
                // Update the rate text field, but ignore tracking.
                var ignoreTracking = true;
                $scope.rateTextFieldChanged(parseFloat(utilityRate), ignoreTracking);
            });
        }

        /**
         * Performs the cost saving calculations for the selected drop down values
         *
         * @param {Boolean} ignoreTracking
         */
        var getCostSavingCalculations = function (ignoreTracking) {
            // convert to cents if gas rate
            var rate = $scope.rateTextField || null;
            if ($scope.energyCostSavingsData.rate_textfield.fuel_type === "gas" && rate !== null) {
                rate = parseFloat(rate) * 100;
            }

            EnergyCostSavingsService.getCostSavingCalculations(
                $scope.selectedCostSavings.value,
                $scope.selectedCostSavingsYears,
                $scope.selectedCostSavingsUsage,
                rate,
                productId
            ).then(function (calculations) {
                $scope.energyCostSavingsCalculations = calculations;
                $scope.hideEnergyCostSavings = false;
                if (!ignoreTracking) {
                    reportEnergyEngagedEvent(rate);
                }
            });
        };

        getCostSavingsInitialData();

        /**
         * Reports the Energy Engaged segment event based on the latest calculated CLEAR_COST/YOUSAVE data
         *
         * @param rate {Number} The energy cost saving's gas rate
         */
        function reportEnergyEngagedEvent(rate) {
            let typeSpecificProperties = {};
            if ($scope.energyCostSavingsCalculations) {
                typeSpecificProperties = getEnergyEngagedEventProperties();
            }

            AnalyticsService.reportEvent('Energy Engaged', {
                rate: rate,
                type: $scope.selectedCostSavings.value,
                usage_amount: $scope.selectedCostSavingsUsage,
                years: $scope.selectedCostSavingsYears,
                ...typeSpecificProperties
            }, $scope.product);
        }

        /**
         * Gets CLEAR_COST or YOUSAVE specific properties to include in the Energy Engaged segment event
         */
        function getEnergyEngagedEventProperties() {
            const toCurrency = $filter('toCurrency');
            let typeSpecificProperties = {};
            if ($scope.selectedCostSavings.value === CLEAR_COST_CODE) {
                typeSpecificProperties.purchase_price = toCurrency($scope.energyCostSavingsCalculations.first_number);
                typeSpecificProperties.energy_cost = toCurrency($scope.energyCostSavingsCalculations.second_number);
                typeSpecificProperties.clear_cost_amount = toCurrency($scope.energyCostSavingsCalculations.third_number);

            } else if ($scope.selectedCostSavings.value === YOUSAVE_CODE) {

                typeSpecificProperties.typical_model = toCurrency($scope.energyCostSavingsCalculations.first_number);
                typeSpecificProperties.this_model = toCurrency($scope.energyCostSavingsCalculations.second_number);
                typeSpecificProperties.yousave_amount = toCurrency($scope.energyCostSavingsCalculations.third_number);
            }
            return typeSpecificProperties;
        }
    }
}

module.exports = energyCostSavingsDirective;
